<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#546e7a"
      d="M45,36c0,0-3.047-7-11-7c-7.957,0-11,7-11,7v3h22V36z"
    />
    <path
      fill="#00acc1"
      d="M24,16c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S24,12.133,24,16 M31,35c0,0-3.875-9-14-9 S3,35,3,35v4h28V35z"
    />
    <path
      fill="#edbd28"
      d="M34,26c3.312,0,6-2.688,6-6s-2.688-6-6-6c-3.313,0-6,2.688-6,6S30.687,26,34,26"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "MemberIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
